import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { useInjectReducer } from 'redux-injectors';
export interface ILocation {
    fullPath: string;
    path: string;
    searchQuery: string;
}
export interface SyncRouterState extends ILocation {}
export const initialState: SyncRouterState = {
    fullPath: '',
    path: '',
    searchQuery: '',
};

const slice = createSlice({
    name: 'router',
    initialState,
    reducers: {
        updatePath: (state, action: PayloadAction<ILocation>) => {
            state.fullPath = action.payload.fullPath;
            state.path = action.payload.path;
            state.searchQuery = action.payload.searchQuery;
        },
    },
});

export const { updatePath } = slice.actions;

export const useSyncRouter = () => {
    useInjectReducer({ key: slice.name, reducer: slice.reducer });
    return { actions: slice.actions };
};
